import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, ViewChild, TemplateRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Location} from '@angular/common';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { DatePipe } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { Observable, map, take } from 'rxjs'; // this created errors ats use below

import { FileUploadsModalComponent } from './../../../manager/file-uploads-modal/file-uploads-modal.component';

import { MysqlService } from './../../../services/mysql.service';
import { Brand } from '../../../shared/models/brand.model';

import { FormsModule, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';

// npm to valiate Australian ABN --  
//::@https://github.com/wojtekmaj/is-valid-abn#readme
import isValidABN from 'is-valid-abn'

@Component({
  selector: 'app-company-edit',
  templateUrl: './company-edit.component.html',
  styleUrls: ['./company-edit.component.css']
})
export class CompanyEditComponent implements OnInit {

  
  stripped: any;
  filenameselected: any;
  get_latest_brand_id: any;
  public nav: any;
  public model;

 

  public baseUploadURL:any;
  @ViewChild('brandForm') form: any;

  bsModalRef: BsModalRef;
  // MODAL
  modalRef: BsModalRef;
  brand_types: any;
  brand: any;
  @Input() brand_id: any;
  DialogObj: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  allRecipients: any;
filename: any;

today = new Date();
today_ISO = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison
  company_global_key_data: any;
  company_global_key: any;
  brand_abn: any;
  is_brand_abn_valid: boolean;
  urlSafe: SafeResourceUrl;
  ABN_website_URL: string;

user_ui_layout_id_Options = [
  { value: '1', label: 'DEFAULT: Client Job Submission' },
  { value: '2', label: 'Advanced: Client Job Submission - subject(s) appened to special instuctions' }
];

  constructor(
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      public toastr: HotToastService,
      vcr: ViewContainerRef,
      private modalService: BsModalService,
      private _location: Location,
      public gfunc: GlobalFunctionsService,
      public datepipe: DatePipe,
      public sanitizer: DomSanitizer,
  ) { 
    this.nav = document.querySelector('nav.navbar');
  
    this.brand_id = +this.route.snapshot.paramMap.get('brand_id');

    // Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


// MYOB/ABN LOOKUP SERVCE WEVSIUTE -- Poperway to include an IFRAM angular sucrutt bypass
this.ABN_website_URL = 'https://abr.business.gov.au/';
this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
  this.ABN_website_URL
);

  }

  ngOnInit() {


    this.baseUploadURL = this.gfunc.baseUploadURL_BrandAssets + '/' + this.brand_id; // no trailing slash
    this.model = new Brand();
    // Set some defaults
    // this.model.is_active = 'Y';
    this.getBrandTypesNoOwner();
    this.getBrandById(this.brand_id);
  }

  getBrandTypes() {
    this._demoService.getBrandBrandTypes().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }


   getBrandTypesNoOwner() {
    this._demoService.getBrandBrandTypesNoOwner().subscribe(
       data => { this.brand_types = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }
  

   getBrandPasswordKeyHash(model) {
    this._demoService.getBrandPasswordKeyHash(model).subscribe(
      data => { 
        this.company_global_key_data = data;
        this.company_global_key = this.company_global_key_data.global_company_key
      
      },
      err => console.error(err),
      () => console.log('done loading company')
    );
  }



// need to change this below
  editBrand(model){
   // model.job_id = this.job_id;
   model.updated_by = this.gfunc.sessionUserId;
   // form switch to allow me to update.
   if (model.change_dates == 1){
   this.toastr.info('date override activated...');
    model.updated = model.updated; 
  }else{
      model.updated = this.today_ISO;
  }

// replace '&' from notes // needs if undefined.
if(model.brand_notes){
  model.brand_notes =  model.brand_notes.replace('&', 'and') // replaces with normal text to stop templates from breaking.
  }

    this._demoService.updateBrand(model).subscribe(
      data => {  // this.trace_candidate_update = data;
        // refresh the list
       // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
      this.toastr.success('Company Updated');
      this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
      this.onOpenDialog(model);
     // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
     // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
      },
      error => {
       // console.error('Error saving Event!');
        this.toastr.error('Error Updating Brand');
       return console.log(error);
      }
     // err => console.error(err),
     // () => console.log('done updates')
  );}


  // Function to sync with myob.
  editBrandMyob(model, myob_customer_model){
    // model.job_id = this.job_id;
     this._demoService.updateBrand(model).subscribe(
       data => {  // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Company Updated');
       this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
       this.onOpenDialog(model);
      // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error Updating Brand');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
   );}



   // MODAL view a component
   openModalWithComponent() {
    const initialState = {
      title: 'Upload Image / Photo',
      item_id: 1010,
      brand_id: this.brand_id,
      size: 'lg',
      backdrop: true,
      IgnoreBackdropClick: false,
    };
    this.bsModalRef = this.modalService.show(FileUploadsModalComponent, {initialState});
    // sets the var to in the component model
    this.bsModalRef.content.brand_id = this.brand_id;
    this.bsModalRef.content.item_id = this.brand_id;
    this.bsModalRef.content.closeBtnName = 'Close';
    this.bsModalRef.content.brand_model = this.brand;
    // subscribed to the emitter and get the value.
              //   this.bsModalRef.content.action.take(1).subscribe((value) => {
              // // console.log(value); // here you will get the value of the file
              // // Remove the "uploads/" part from the filename.
              // this.filenameselected = value;
              // this.stripped = this.filenameselected.replace('uploads/', '');
              // // this.model.main_image = this.stripped; // works for simple add not update.
              // // console.log(this.stripped);
              // // console.log(this.model);
              // this.form.logo = this.stripped;
              // // this.form.reset();
              // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
              // this.form.controls['logo'].patchValue(this.form.logo);
              
              // });
              // modal component method clickOK to run local method addFileNameFromModal
              // this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
              this.bsModalRef.content.action.subscribe(this.addFileNameFromModal.bind(this)); /// THIS WORKLED // when clicked.....
              
              

              // return this.modalRef.content.onClose;

  }

   // to router navigate back
   public goBack() {
    this._location.back();
  }

  brandView(brand_id) {
    // this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
    this.gfunc.globalBrandView(brand_id);
  }
  
  brandEdit(brand_id) {
    // this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
    this.gfunc.globalbrandEdit(brand_id);
  }




// syncfusion dialog simple sample
public onOpenDialog = function(event: any): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Updated Company',
    content: 'Successfully Updated Company and Data Saved. You may continue.',
    okButton: {  text: 'Ok', click: this.okClick.bind(this) },
  // cancelButton: {  text: '.', click: this.cancelClick.bind(this) },
  cancelButton: {  text: '.', click: this.okClick.bind(this) },
  showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
public okClick(): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.JSON_job);
// this.createJobSubjectsMultiple(this.newSubject);
 this.DialogObj.hide();
//  this.router.navigate(['/admin/brands/companies']);
 this.gfunc.globalBrandView(this.brand_id);
}; // end functiiom

private cancelClick(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
   this.modalRef.hide(); // hide the modal?
}







// :: Parent / Child modal test
closeParentModelDefault(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
};


// :: Parent / Child modal test
addRecipientFromModal(model) {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

          // this.allRecipients.push({
          //   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
          //   recipient_email_address: model.recipient_email_address,
          //   recipient_brand_id: null,
          //   recipient_brand_type_id: null,
          //   recipient_user_id: null,
          //   recipient_user_level_id: null,
          //   recipient_type_name: model.recipient_type_name,
          // });

          // this.allRecipients = this.allRecipients;
          // this.model.allRecipients = this.allRecipients;



                  // this.filenameselected = model.new_filename;
                  // this.stripped = this.filenameselected.replace('uploads/', '');
                  // // this.model.main_image = this.stripped; // works for simple add not update.
                  // // console.log(this.stripped);
                  // // console.log(this.model);
                  // this.form.logo = this.stripped;
                  // // this.form.reset();
                  // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                  // this.form.controls['logo'].patchValue(this.form.logo);


          this.model.logo = 'New Logo';
          this.form.controls['logo'].patchValue(this.model.logo); // works by setting the new frorm value from parent modal.


this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};



// :: Parent / Child modal test
public addFileNameFromModal(filename) {

  // alert('Clicked');
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  // this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);

          // this.allRecipients.push({
          //   recipient_name: model.recipient_name + ' - ' + model.recipient_type_name,
          //   recipient_email_address: model.recipient_email_address,
          //   recipient_brand_id: null,
          //   recipient_brand_type_id: null,
          //   recipient_user_id: null,
          //   recipient_user_level_id: null,
          //   recipient_type_name: model.recipient_type_name,
          // });

          // this.allRecipients = this.allRecipients;
          // this.model.allRecipients = this.allRecipients;



                  // this.filenameselected = model.new_filename;
                  // this.stripped = this.filenameselected.replace('uploads/', '');
                  // // this.model.main_image = this.stripped; // works for simple add not update.
                  // // console.log(this.stripped);
                  // // console.log(this.model);
                  // this.form.logo = this.stripped;
                  // // this.form.reset();
                  // // must set  @ViewChild('brandForm') form: any; declaration in top of component first!
                  // this.form.controls['logo'].patchValue(this.form.logo);
// console.log('Returned Filename: ' , filename);

          // this.model.logo = filename;
          this.form.controls['logo'].patchValue(filename); // works by setting the new frorm value from parent modal.


// this.modalRef.hide();
// console.log('Added External Recipeint.');
// this.toastr.info('External Recipient Added');
};


  // MODAL
  // start of modal windows service as a template
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


  
  // :: Parent / Child modal test
  closeParentModel() {
    // alert('parent component function.');
    this.modalRef.hide();
   // this.refreshGrid(); // resets the grid if updated and closed.
  //  this.updateTypeClick = false; // closes the div
  };
  


  
  getBrandById(brand_id) {
    this._demoService.getBrandById(brand_id).subscribe(
      data => { this.brand = data;
      
      this.brand_abn = data[0].abn
      this.is_brand_abn_valid = isValidABN(this.brand_abn )
      
      },
      err => console.error(err),
      () => console.log('done loading company')
    );
  }


checkABN(model){
  this.is_brand_abn_valid;
  this.is_brand_abn_valid =  isValidABN(model.abn )
  // this.model = this.model
}

}
